import { render, staticRenderFns } from "./ProfileEditTabInformation.vue?vue&type=template&id=9273d22c&"
import script from "./ProfileEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./ProfileEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProfileEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports